import { MultiString } from "../../../../library-js/i18n/MultiString";

export enum ProductType
{
  DESKTOP_APP,
  VIDEO_GAME,
  ADD_ON,
  SUPPORT,
  EARLY_ACCESS,
  MEMBERSHIP
  
}

export class ProductTypes 
{
  static readonly [ ProductType.DESKTOP_APP ]:MultiString = 
  {
    en: "DESKTOP APP"
  }

  static readonly [ ProductType.VIDEO_GAME ]:MultiString = 
  {
    en: "VIDEO GAME"
  }

  static readonly [ ProductType.ADD_ON ]:MultiString = 
  {
    en: "ADD ON"
  }

  static readonly [ ProductType.SUPPORT ]:MultiString = 
  {
    en: "SUPPORT"
  }

  static readonly [ ProductType.EARLY_ACCESS ]:MultiString = 
  {
    en: "EARLY ACCESS"
  }

  static readonly [ ProductType.MEMBERSHIP ]:MultiString = 
  {
    en: "MEMBER SHIP"
  }
}